import React, {useEffect, useRef, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import './invoice-template.scss';
import {RouteComponentProps} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from 'app/config/store';
import {getEntity, updateEntity} from '../quotation.reducer';
import {
  deleteFileFromS3,
  downloadFileFromS3,
  uploadFileToS3
} from "app/entities/file/S3File.reducer";
import {sanitizeFileName} from "app/shared/util/file-utils";
import {InvoicePrint} from 'app/entities/quotation/invoice-print';
import {InvoicePrint as BoubyanInvoicePrint} from 'app/entities/quotation/client-docs/boubyan-bank/invoice/invoice-print';
import {isBoubyanQuotation} from 'app/shared/util/quotation-utils';

export const InvoiceTemplate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const quotationEntity = useAppSelector(state => state.quotation.entity);
  const [hasGenerated, setHasGenerated] = useState(false);

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);
  const captureRef = useRef(null);

  const getStaffFullName = createdUser => {
    if (!createdUser || typeof createdUser !== 'object') {
      return '';
    }

    const { firstName, lastName } = createdUser;
    if (!firstName || !lastName) {
      return '';
    }

    const fullName = `${firstName} ${lastName}`;
    return fullName;
  };

  const generateInvoiceNumber = () => {
    const currentYear = new Date().getFullYear();
    const purchaseOrderNumber = quotationEntity?.purchaseOrder?.poNumber || '00000';
    return `INV/${currentYear}/${purchaseOrderNumber}`;
  };

  const generatePDFArabic = async () => {
    if (hasGenerated) return;
    setHasGenerated(true);

    if (quotationEntity?.invoice) {
      await deleteUploadedFile(quotationEntity.invoice);
    }

    const element = captureRef.current;
    if (!element) return;

    const scale = 4;
    const canvas = await html2canvas(element, { scale });
    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'pt', 'a4', true);

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = canvas.width / scale;
    const imgHeight = canvas.height / scale;
    let width, height;

    if (imgWidth / pdfWidth > imgHeight / pdfHeight) {
      width = pdfWidth;
      height = (imgHeight / imgWidth) * pdfWidth;
    } else {
      height = pdfHeight;
      width = (imgWidth / imgHeight) * pdfHeight;
    }

    pdf.addImage(imgData, 'PNG', 0, 0, width, height);

    const blob = pdf.output('blob');

    const invoiceNumber = generateInvoiceNumber();
    const safeFileName = sanitizeFileName(invoiceNumber) + '.pdf';

    const file = new File([blob], safeFileName, { type: 'application/pdf' });

    await handleUploadAndDownload(file, safeFileName);
  };

  const handleUploadAndDownload = async (blob: Blob, fileName: string) => {
    const file = new File([blob], fileName, { type: 'application/pdf' });

    const formData = new FormData();
    formData.append('file', file);

    const updatedFilePath = `invoice/${fileName}`;

    try {
      await dispatch(uploadFileToS3({ formData }));

      await dispatch(
        updateEntity({
          ...quotationEntity,
          invoice: updatedFilePath,
        })
      );

      // Download the uploaded file
      await downloadFile('invoice', fileName);

    } catch (error) {
      console.error('Error uploading or downloading file:', error);
    }
  };

  const downloadFile = async (folderPath: string, fileName: string) => {
    try {
      const linkButton = document.querySelector('.link-button');
      if (linkButton) {
        linkButton.classList.add('loading');
      }
      document.body.classList.add('loading');

      const resultAction = await dispatch(downloadFileFromS3({ folderPath, fileName }));

      if (downloadFileFromS3.fulfilled.match(resultAction)) {
        const blob = resultAction.payload;

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      } else {
        throw new Error('Failed to download file');
      }
    } catch (error) {
      console.error('Error fetching file:', error);
    } finally {
      document.body.classList.remove('loading');
      const linkButton = document.querySelector('.link-button');
      if (linkButton) {
        linkButton.classList.remove('loading');
      }
    }
  };

  const deleteUploadedFile = async (filePath: string): Promise<void> => {
    if (!filePath) return;

    try {
      const resultAction = await dispatch(deleteFileFromS3({ filePath }));

      if (deleteFileFromS3.fulfilled.match(resultAction)) {
        console.warn('File deleted successfully');
      } else {
        throw new Error('Delete failed');
      }
    } catch (error) {
      console.error('Error deleting file:', error);
    }
  };

  useEffect(() => {
    if (!hasGenerated && quotationEntity?.purchaseOrder?.poNumber) {
      generatePDFArabic();
    }
  }, [quotationEntity, hasGenerated]);

  return (
    // <InvoicePrint quotationEntity={quotationEntity} captureRef={captureRef}/>

  isBoubyanQuotation(quotationEntity)
    ? <BoubyanInvoicePrint quotationEntity={quotationEntity} captureRef={captureRef}/>
    : <InvoicePrint quotationEntity={quotationEntity} captureRef={captureRef}/>
  );


}
export default InvoiceTemplate;
